export default __webpack_public_path__ + "static/media/more-info-1.84fea794.png";